var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-left"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/index"}},[_c('img',{attrs:{"src":require("../assets/img/logo.png"),"height":"40","alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }